import React from "react";
import styles from "./ArticleHeader.module.less";
import Container from "../Container/Container";
import { Link } from "react-router-dom";

export interface Props {
    image?: string;
    imageHeight?: number;
    backgroundImage?: string;
    heading: string;
    preHeading?: string;
    onClose?: () => void;
}

export default function ArticleHeading(props: Props) {
    return (
        <header
            className={styles.ArticleHeader}
            style={{ backgroundImage: props.backgroundImage ? `url(${props.backgroundImage})` : undefined }}
        >
            <Container>
                <Link to="/">
                    <img src={props.image} alt={props.heading} height={props.imageHeight} />
                </Link>
                {props.preHeading ? (
                    <span className={styles["ArticleHeader-preHeading"]}>{props.preHeading}</span>
                ) : null}
                <h1 className={styles["ArticleHeader-heading"]}>{props.heading}</h1>

                {props.onClose ? (
                    <button className={styles["ArticleHeader-close"]} onClick={props.onClose}>
                        <img src={process.env.PUBLIC_URL + "/assets/close.svg"} alt="Close icon" />
                    </button>
                ) : null}
            </Container>
        </header>
    );
}
